/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { AuthenticateRequest } from '../model/authenticateRequest';
import { AuthenticateResponse } from '../model/authenticateResponse';
import { CheckTokenRequest } from '../model/checkTokenRequest';
import { CheckTokenResponse } from '../model/checkTokenResponse';
import { CreateRequest } from '../model/createRequest';
import { CreateResponse } from '../model/createResponse';
import { InviteRequest } from '../model/inviteRequest';
import { InviteResponse } from '../model/inviteResponse';
import { ResetEmailRequest } from '../model/resetEmailRequest';
import { ResetEmailResponse } from '../model/resetEmailResponse';
import { ResetPasswordRequest } from '../model/resetPasswordRequest';
import { ResetPasswordResponse } from '../model/resetPasswordResponse';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class LoginApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public authenticateObservable: AuthenticateResponse | undefined = undefined;

    /**
     * Authenticates user.
     * 
     * @param body 
     */
    @action
    public authenticate(body?: AuthenticateRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<AuthenticateResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<AuthenticateResponse>(
            `${this.basePath}/api/login/authenticate`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.authenticateObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public checkTokenObservable: CheckTokenResponse | undefined = undefined;

    /**
     * Checks token.
     * 
     * @param body 
     */
    @action
    public checkToken(body?: CheckTokenRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<CheckTokenResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<CheckTokenResponse>(
            `${this.basePath}/api/login/checktoken`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.checkTokenObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public createObservable: CreateResponse | undefined = undefined;

    /**
     * Creates user.
     * 
     * @param body 
     */
    @action
    public create(body?: CreateRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<CreateResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<CreateResponse>(
            `${this.basePath}/api/login/create`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.createObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public inviteObservable: InviteResponse | undefined = undefined;

    /**
     * Sends invitation email to user.
     * 
     * @param body 
     */
    @action
    public invite(body?: InviteRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<InviteResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<InviteResponse>(
            `${this.basePath}/api/login/invite`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.inviteObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public logOutObservable: AuthenticateResponse | undefined = undefined;

    /**
     * Deauthenticates user.
     * 
          */
    @action
    public logOut(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<AuthenticateResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<AuthenticateResponse>(
            `${this.basePath}/api/login/logout`,
            null,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.logOutObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public resetEmailObservable: ResetEmailResponse | undefined = undefined;

    /**
     * Sends email with password reset link to user.
     * 
     * @param body 
     */
    @action
    public resetEmail(body?: ResetEmailRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<ResetEmailResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<ResetEmailResponse>(
            `${this.basePath}/api/login/reset/email`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.resetEmailObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public resetPasswordObservable: ResetPasswordResponse | undefined = undefined;

    /**
     * Resets user&#x27;s password.
     * 
     * @param body 
     */
    @action
    public resetPassword(body?: ResetPasswordRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<ResetPasswordResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<ResetPasswordResponse>(
            `${this.basePath}/api/login/reset/password`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.resetPasswordObservable = response.data);
            }
            return response;
        });
    }

}
